{
  "appPoweredBy": "powered by {name}",
  "loading": "Loading…",
  "save": "Save",
  "saving": "Saving…",
  "saved": "Saved",
  "cancel": "Cancel",
  "close": "Close",
  "back": "Back",
  "next": "Next",
  "edit": "Edit",
  "delete": "Delete",
  "remove": "Remove",
  "add": "Add",
  "search": "Search",
  "filter": "Filter",
  "filters": "Filters",
  "clear": "Clear",
  "retry": "Try again",
  "submit": "Submit",
  "send": "Send",
  "yes": "Yes",
  "no": "No",
  "unknown": "Not sure",
  "optional": "optional",
  "required": "required",
  "seeAll": "See all",
  "loadMore": "Load more",
  "share": "Share",
  "copied": "Link copied",
  "offline": "You are offline. Showing saved information.",
  "offlineShort": "Offline",
  "backOnline": "Back online",
  "savedWillSend": "Saved — will send when online",
  "pendingSend": "{count} waiting to send",
  "lastUpdated": "Last updated by {office} on {date}",
  "updatedOn": "Updated {date}",
  "call911": "Call 911",
  "emergency": "Emergency",
  "reportEmergency": "Report an emergency",
  "verified": "Verified LGU office",
  "townWide": "Town-wide",
  "barangay": "Barangay",
  "allBarangays": "All barangays",
  "chooseBarangay": "Choose your barangay",
  "signIn": "Sign in",
  "signOut": "Sign out",
  "signUp": "Create account",
  "notFound": "We couldn't find that page.",
  "goHome": "Go to home",
  "errorTitle": "Something went wrong",
  "privacyNotice": "Privacy notice",
  "consentDefault": "I agree that the LGU may collect and use this information for this purpose, as described in the privacy notice (Data Privacy Act of 2012, RA 10173).",
  "consentLocation": "This form collects your location, photos and contact details. The LGU uses them only to respond to this report, under the Data Privacy Act of 2012 (RA 10173). Location is saved only with this report; we never track you.",
  "readPrivacy": "Read the privacy notice",
  "photos": "Photos",
  "addPhoto": "Add photo",
  "takePhoto": "Take or choose a photo",
  "removePhoto": "Remove photo",
  "useMyLocation": "Use my location",
  "locating": "Finding your location…",
  "locationDenied": "Location is turned off. Choose your barangay instead.",
  "today": "Today",
  "tomorrow": "Tomorrow",
  "thisWeek": "This week",
  "all": "All",
  "none": "None",
  "status": "Status",
  "details": "Details",
  "name": "Name",
  "mobile": "Mobile number",
  "email": "Email",
  "password": "Password",
  "landmark": "Landmark",
  "notes": "Notes",
  "description": "Description",
  "date": "Date",
  "time": "Time",
  "from": "From",
  "to": "To",
  "export": "Export",
  "print": "Print",
  "download": "Download",
  "open": "Open",
  "view": "View",
  "new": "New"
}
